import { useTranslation } from "react-i18next";
import { Input } from "@/components/atomic/Input";
import { ChatAttributeFilter, createChatNumericalAttributeFilter } from "@/components/ui/chat/chatFilterUtils";
import { Attribute, AttributeType } from "@/models/attribute";

interface NumericalAttributeFilterProps {
  attribute: Attribute;
  currentFilter: ChatAttributeFilter | undefined;
  onFilterChange: (attributeName: string, filter: ChatAttributeFilter | null) => void;
}

export const NumericalAttributeFilter: React.FC<NumericalAttributeFilterProps> = ({
  attribute,
  currentFilter,
  onFilterChange,
}) => {
  const { t } = useTranslation("voiceek_ui");

  const minValue = currentFilter?.filter.type === AttributeType.NUMERICAL
    ? currentFilter.filter.gte ?? null
    : null;
  const maxValue = currentFilter?.filter.type === AttributeType.NUMERICAL
    ? currentFilter.filter.lte ?? null
    : null;

  const handleChange = (min: number | null, max: number | null) => {
    // 両方がnullの場合はフィルタを削除
    if (min === null && max === null) {
      onFilterChange(attribute.name, null);
    } else {
      const chatFilter = createChatNumericalAttributeFilter(min, max);
      onFilterChange(attribute.name, chatFilter);
    }
  };

  return (
    <div className="flex flex-col gap-2 my-4">
      {/* 範囲指定 */}
      <div className="flex items-center gap-2">
        <span className="text-[14px] text-[#333333]">
          {t("chat.filter.specifyByNumber")}
        </span>
        <div className="flex items-center gap-2 ml-2">
          <Input
            value={minValue ?? ""}
            type="number"
            onChange={(e) => {
              const value = e.target.value;
              handleChange(value === "" ? null : Number(value), maxValue);
            }}
            className="no-spin w-[80px] text-[14px] min-h-[32px] py-2 px-3 border-[#b7b7b7] shadow-none placeholder:text-[#b7b7b7]"
          />
          <span className="text-[14px] text-[#333333]">〜</span>
          <Input
            value={maxValue ?? ""}
            type="number"
            onChange={(e) => {
              const value = e.target.value;
              handleChange(minValue, value === "" ? null : Number(value));
            }}
            className="no-spin w-[80px] text-[14px] min-h-[32px] py-2 px-3 border-[#b7b7b7] shadow-none placeholder:text-[#b7b7b7]"
          />
        </div>
      </div>

      {/* エラーメッセージ */}
      {currentFilter?.error && (
        <p className="text-[12px] text-red-500 ml-[110px]">
          {t(currentFilter.error)}
        </p>
      )}
    </div>
  );
};
